import firebase from "firebase";
import React from "react";

const Login = () => {
  const googleProvider = new firebase.auth.GoogleAuthProvider();

  return (
    <button style={{ margin: '10px auto', height: 40, cursor: 'pointer', width: 'fit-content' }}
      onClick={async (event) => {
        event.preventDefault();
        await firebase.auth().signInWithPopup(googleProvider);
      }}
    >
      Sign in with your Wavepaths Google account
    </button>
  );
};

export default Login;
